import type { ButtonHTMLAttributes } from "react";

export type Variant = "primary" | "danger" | "secondary";

export const BUTTON_BASE_CLASSES =
  "rounded-full px-8 py-3 text-center font-sans text-lg font-semibold uppercase tracking-wide transition-colors disabled:cursor-not-allowed disabled:opacity-60";

export const BUTTON_VARIANT_CLASSES: Record<Variant, string> = {
  primary: "bg-steel text-white hover:bg-steel/90",
  danger: "bg-deep-red text-white hover:bg-deep-red/90",
  secondary: "border-2 border-ink text-ink hover:bg-ink hover:text-white",
};

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
};

export default function Button({
  variant = "primary",
  className = "",
  disabled,
  children,
  ...props
}: ButtonProps) {
  return (
    <button
      className={`${BUTTON_BASE_CLASSES} ${BUTTON_VARIANT_CLASSES[variant]} ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}
